module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_f_albino.6d384bf2.png";